import {INCOME_PERIOD, TaxRateDto} from "./tax-rate.dto";
import {TaxReliefType} from "./tax-relief-type.dto";
import {PaginatorInfo} from "./generic.dto";
import { Country } from "./country.dto";
import { PayrollCompanyDto } from "./company-account.dto";

export type TaxRelief = {
  id: number
  countryId: number
  rateComponent: number
  fixedComponent: number | null
  taxReliefTypeId: number
  incomePeriod: INCOME_PERIOD
  amountDerivedFrom: PayrollComponent
  benchmarkRateComponent: number | null
  benchmarkFixedComponent: number | null
  name: string
  companyId: number | null
  createdAt: string
  modifiedAt: string | null
}

export enum PayrollComponent {
  BASIC = "BASIC",
  GROSS = "GROSS",
  TOTAL_CASH_EMOLUMENT = "TOTAL_CASH_EMOLUMENT",
  ASSESSABLE_INCOME = "ASSESSABLE_INCOME",
}

export class CreateTaxReliefDto {
  countryId!: number
  rateComponent!: number
  fixedComponent?: number
  taxReliefTypeId!: number
  incomePeriod!: INCOME_PERIOD
  amountDerivedFrom?: PayrollComponent
  benchmarkRateComponent?: number
  benchmarkFixedComponent?: number
  name!: string
  /** @ignore */ companyId?: number | null;
}

export type CreateCompanyTaxReliefDto
  = Omit<CreateTaxReliefDto, 'countryId' | 'companyId'>;

export interface TaxReliefDto extends TaxRelief {
  taxReliefType?: TaxReliefType;
  country?: Country
  company?: PayrollCompanyDto
}

export interface TaxReliefPaginator extends PaginatorInfo<TaxReliefDto> {}

export class UpdateTaxReliefDto {
  rateComponent?: number
  fixedComponent?: number
  taxReliefTypeId?: number
  incomePeriod?: INCOME_PERIOD
  amountDerivedFrom?: PayrollComponent
  benchmarkRateComponent?: number
  benchmarkFixedComponent?: number
  name?: string
}

export class QueryTaxReliefDto {
  countryId?: number;
  taxReliefTypeId?: number
  incomePeriod?: INCOME_PERIOD;
  amountDerivedFrom?: PayrollComponent
  /** Accepts a value of 0 for non-company tax reliefs */
  companyId?: number;
  page?: number = 1;
  limit?: number;
  orderBy?: TaxReliefOrderBy = TaxReliefOrderBy.CREATED_AT_ASC;
}

export enum TaxReliefOrderBy {
  CREATED_AT_ASC = 'createdAt:asc',
  CREATED_AT_DESC = 'createdAt:desc',
  MODIFIED_AT_ASC = 'modifiedAt:asc',
  MODIFIED_AT_DESC = 'modifiedAt:desc'
}